import React, { FC } from "react";
import { Backdrop, Button } from "@mui/material";
import styles from './SubmissionErrorModal.module.scss';

interface SubmissionErrorModalProps {
  onClose?: () => void;
  message?: string;
}

const SubmissionErrorModal: FC<SubmissionErrorModalProps> = ({
  onClose,
  message,
}) => {
  return (
    <div className="create-promotion-modal">
      <Backdrop open={true}>
        <div className={styles["modalContainer"]}>
          <h4 className={styles["modalContainer__title"]}>Try again?</h4>

          <div className={styles["modalContainer__inputWrapper"]}>
            {message || "Another order is in progress. Please try again later."}
          </div>

          <div className={styles["modalContainer__buttonGroup"]}>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#0e0f0c", color: "#fff" }}
              fullWidth
              onClick={onClose}
            >
              Ok
            </Button>
          </div>
        </div>
      </Backdrop>
    </div>
  );
};

export default SubmissionErrorModal;
